<template>
    <div>
        <div
            class="toast qg-unpublished-page inactive-page-version-toast hidden"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            data-autohide="false"
            data-animation="false"
        >
            <div class="toast-header bg-danger text-white">
                <strong class="mr-auto">You are viewing an inactive page version!</strong>
            </div>
            <div class="toast-body p-10 text-left">
                <p>This page version is only visible for content publishers.</p>
            </div>
        </div>

        <div
            class="toast qg-unpublished-page unpublished-page-toast hidden"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            data-autohide="false"
            data-animation="false"
        >
            <div class="toast-header bg-danger text-white">
                <strong class="mr-auto">You are viewing an unpublished page!</strong>
            </div>
            <div class="toast-body p-10 text-left">
                <p>This page is only visible for content publishers.</p>
            </div>
        </div>
    </div>
</template>

<script>
import { globalLogger } from '../../../../helper/global-logger';
import 'bootstrap/js/dist/toast';
import { testIsFalseish } from '../../../../../lib/test-and-assert/test-base';

var init = function () {
    let isPageVersionActiveFalse = $('#pageVersionActivatingStatus').val();
    let isPagePublishedFalse = $('#pagePublishedFalse').val();
    let currentUrl = window.location.href;

    if (currentUrl.indexOf('.test') === false) {
        globalLogger.log('Page is visible even though it should not be!');
    }

    if (!testIsFalseish(isPageVersionActiveFalse)) {
        $('.inactive-page-version-toast').toast('show');
    }

    if (!testIsFalseish(isPagePublishedFalse)) {
        $('.unpublished-page-toast').toast('show');
    }
};

export default {
    name: 'UnpublishedPage',
    mounted() {
        init();
    },
    methods: {},
};
</script>
